import React from "react"
import { StaticQuery, graphql } from "gatsby"

const JobOpeningsQuery = ({ render: Render }) => (
  <StaticQuery
    query={graphql`
      query {
        allContentfulJobOpening {
          edges {
            node {
              id
              title
              department
              link
              location {
                city
                state
              }
            }
          }
        }
      }
    `}
    render={data => {
      const jobOpenings = data.allContentfulJobOpening.edges.map(({ node }) => node) || []
      return <Render data={{ jobOpenings }} />
    }}
  />
)

export default JobOpeningsQuery
